import $ from "vendors/zepto";
import * as React from "react";
import { render } from "react-dom";
import "common/sentry";

import Cart from "models/cart";
import { redirect } from "utils/common";
import Main from "./main";
import { isNil } from "lodash";
import { post } from "utils/ajax";

declare var currentCartId: string;
declare var lastCartId: string;

function init() {
  // If this is an authenticated user and there is a cart id in localStorage,
  // this means that the customer is seeing the cart page refreshed after her successful
  // login or registration request after clicking on the "check out" button.
  // So let's clear up the localStorage and take her to the correct checkout page.
  let cart_id = localStorage.getItem("guestCartId");
  if (window.isAuthenticatedUser && !isNil(cart_id)) {
    // If any cart available in localStorage assign it to current user
    return post(
      "/api/v1/cart/do_assign_guest_cart",
      { secure_id: cart_id },
      () => {
        let redirect_to_checkout = localStorage.getItem("redirect_to_checkout");
        // After cart assigned to the customer it is important to clear it from localStorage.
        localStorage.removeItem("redirect_to_checkout");
        localStorage.removeItem("guestCartId");
        localStorage.removeItem("guestOrderItemId");
        let page = redirect_to_checkout ? "checkout" : "cart";
        redirect(`/${page}/${cart_id}`);
      }
    );
  }

  // If we come to here, there are four possibilities:
  // 1. Logged in customer just need to load the cart content from the server using `lastCartId`. Easy.
  // 2. We are an anonymous visitor with a cart id in my localStorage. The action is the same as above.
  //
  // 3. We are both anonymous and have no cart. If this is the case, we need to post to server so a new
  //    cart will be created.
  //    The cart returned from `Cart.init` has no `id`, but the `init > populate_with_server_data`
  //    chain will populate it. Therefore, we return a `cart` below but not using it elsewhere.
  //
  // 4. Admin is looking at the cart from an order. In this case, the `lastCartId` differs
  //    from `currentCartId`. The former points to the admin last cart whereas latter the correct one.
  //    The `currentCartId` should take preferences over `lastCartId`. See SITE-991.
  //    Also, refer to `test_views_cart.py:CartJsCartIdIsPassedInTest` for more context.
  let cart = Cart.init(cart_id || currentCartId || lastCartId, () => {
    if (!window.isAuthenticatedUser && isNil(cart_id)) {
      localStorage.setItem("guestCartId", cart.id);
    }
    render(
      React.createElement(Main, {
        cart: cart,
        hasCheckout: window.hasCheckout
      }),
      document.getElementById("mount_point")
    );
  });
}

init();

$(".pair-with-suggestions .btn-success").click(e => {
  let $container = $(e.currentTarget);
  let product = $container.data("product"),
    size = $container.data("size");
  redirect(
    `/cart/do_add_accessory?cart=${currentCartId ||
      lastCartId}&product=${product}&size=${size}`
  );
});
